import { render, staticRenderFns } from "./avalonMenuSettings.vue?vue&type=template&id=17601492&scoped=true&"
import script from "./avalonMenuSettings.vue?vue&type=script&lang=js&"
export * from "./avalonMenuSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17601492",
  null
  
)

export default component.exports